<template>
  <div class="study_profile_modal__wrapper">
    <div class="study_profile_modal__container custom-width">

      <!-- HEADER -->
      <div class="modal__title d-flex justify-content-between py-2   px-3">
        <h4 class="mb-0" v-if="patientId == '0'">{{ $t("navigations.subject registration") }}</h4>
        <h4 class="mb-0" v-else>{{ $t("navigations.update subject") }}</h4>

        <div class="tooltip-wrapper pointer">
          <i class="fa fa-times" @click.prevent="closeModal"></i>
          <span class="custom-tooltip">{{ $t("navigations.close") }}</span>
        </div>
      </div>

      <div class="ibox-content p-3">

        <!-- SUBJECT BASIC DETAILS -->

        <div class="section-header d-flex justify-content-between align-items-center" @click="toggleSection('basic')">

          <h4 class="mb-0">Subject Basic Details</h4>

          <i class="fa" :class="sectionState.basic ? 'fa-chevron-up' : 'fa-chevron-down'">
          </i>

        </div>

        <div v-show="sectionState.basic">
          <div class="form-group row">
            <input type="hidden" v-model="values.patientId" />
            <div class="col-lg-4 mb-1">
              <label class="col-form-label">
                {{ $t("navigations.site code") }}
                <sup><i class="fa fa-asterisk required"></i></sup>
              </label>
              <select class="form-control" v-model="values.siteId"
               :disabled="patientId != 0">
                <option v-for="site in sites" :key="site.siteID" :value="site.siteID">
                  {{ site.siteCode }}
                </option>
              </select>
              <!-- ERROR -->
              <small class="errorClass" v-if="!validations[0]">
                Site Code is required
              </small>

            </div>

            <div class="col-lg-4 mb-1">
              <label class="col-form-label">
                {{ $t("navigations.subject id") }}
                <sup><i class="fa fa-asterisk required"></i></sup>
              </label>
              <input type="text" class="form-control" :disabled="patientId != 0" v-model="values.subjectId" maxlength="1000" />
              <!-- ERROR -->
              <small class="errorClass" v-if="!validations[1]">
                Subject ID is required
              </small>

            </div>

            <div class="col-lg-4">

              <label class="col-form-label">
                Arm Code
              </label>

              <select class="form-select" v-model="values.armCode">
                <option value="" disabled>Select</option>

                <option v-for="arm in armList" :key="arm.ArmCode" :value="arm.ArmCode">

                  {{ arm.ArmCode }}

                </option>

              </select>
             <small class="errorClass" v-if="!validations[3]">
                Arm Code is required
              </small>

            </div>
            <div class="col-lg-4 mb-1">
              <label class="col-form-label">{{ $t("navigations.investigator") }}</label>
              <select class="form-select" name="account" v-model="values.nurseName">
                <option value="" disabled="">Select</option>
                <option v-for="user in users" :key="user.userID" :value="user.email">
                  {{ user.name }}
                </option>
              </select>
            </div>

            <div class="col-lg-4">

              <label class="col-form-label">
                Status
              </label>

              <select class="form-select" v-model="values.status">
                <option value="" disabled="">Select</option>
                <option v-for="status in statusList" :key="status.StatusId" :value="status.status">

                  {{ status.status }}

                </option>

              </select>

            </div>

            <div class="col-lg-4">

              <label class="col-form-label">
                Milestone
              </label>

              <select class="form-select" v-model="values.milestone">
                <option value="" disabled="">Select</option>
                <option v-for="milestone in milestoneList" :key="milestone.id" :value="milestone.milestoneName">

                  {{ milestone.milestoneName }}

                </option>

              </select>

            </div>
            <div class="col-lg-2">

              <label>Pre Visit</label>

              <input type="text" class="form-control" v-model="values.preVisit" />

            </div>

            <div class="col-lg-2">

              <label>Post Visit</label>

              <input type="text" class="form-control" v-model="values.postVisit" />

            </div>
            <div class="col-lg-4 mb-1">

              <label class="col-form-label">
                {{ $t("navigations.country") }}
              </label>

              <select class="form-select" v-model="values.country">

                <option v-for="country in countries" :key="country.code" :value="country.name">

                  {{ country.name }}

                </option>

              </select>

            </div>
            <div class="col-lg-4 mb-1">

              <label class="col-form-label">
                {{ $t("navigations.city") }}
              </label>

              <input type="text" class="form-control" v-model="values.city" />

            </div>

            <div class="col-lg-4 mb-1">

              <label class="col-form-label">
                {{ $t("navigations.post/zip code") }}
              </label>

              <input type="text" class="form-control" v-model="values.zipCode" />

            </div>

            <div class="col-lg-4 mb-1">

              <label class="col-form-label">
                {{ $t("navigations.language") }}
              </label>

              <select class="form-control" v-model="values.language">

                <option v-for="language in languages" :key="language.id">

                  {{ language.language }}

                </option>

              </select>

            </div>

            <div class="col-lg-6 mb-1">

              <label class="col-form-label">
                {{ $t("navigations.subject notes") }}
              </label>

              <input type="text" class="form-control" v-model="values.patientNotes" />

            </div>
            <div class="col-lg-2 mt-4">

              <label>
                Active
              </label>&nbsp;

              <input type="checkbox" v-model="values.active" />

            </div>

          </div>
        </div>

        <!-- CONSENT SECTION -->

        <div class="section-header d-flex justify-content-between align-items-center mt-3"
          @click="toggleSection('consent')">
          <h4 class="mb-0">Informed Consent</h4>
          <i class="fa" :class="sectionState.consent ? 'fa-chevron-up' : 'fa-chevron-down'">
          </i>
        </div>

        <div v-show="sectionState.consent">

          <div class="form-group row">


            <div class="col-lg-6 mt-4">

              <label>Has the patient signed the informed consent?</label>&nbsp;

              <input type="checkbox" v-model="values.isConsentSigned" @change="handleConsentCheck" />

            </div>

            <div class="col-lg-4">

              <label class="mb-0">
                Consent Date
                <sup v-if="values.isConsentSigned"><i class="fa fa-asterisk required"></i></sup>
              </label>

              <input type="date" class="form-control" v-model="values.consentSignedDate" />
              <!-- ERROR -->
              <small class="errorClass" v-if="!validations[5]">
                Consent Date is required
              </small>
            </div>

          </div>

        </div>
        <!-- Cohort -->
         <div class="section-header d-flex justify-content-between align-items-center mt-3"
          @click="toggleSection('cohort')">
          <h4 class="mb-0">Cohort Assignment</h4>
          <i class="fa" :class="sectionState.cohort ? 'fa-chevron-up' : 'fa-chevron-down'">
          </i>
        </div>
        <div v-show="sectionState.cohort">

          <div class="form-group row">
             <div class="col-lg-6 mt-4">

              <label>Select a cohort for this subject</label>
              </div>


            <div class="col-lg-4">

              <label class="col-form-label">
                Cohort
              </label>

              <select class="form-select" v-model="values.cohortId">
                <option value="" disabled>Select</option>

                <option v-for="cohort in cohortList" :key="cohort.id" :value="cohort.id">
                  {{ cohort.cohortName }}({{ cohort.cohortCode }})
                </option>
              </select>

            </div>

          </div>

        </div>

        <!-- SCREENING -->
        <div>
          <div class="section-header d-flex justify-content-between align-items-center mt-3"
            @click="toggleSection('phases')">

            <h4 class="mb-0">Visit Planning by Study Phase</h4>

            <i class="fa" :class="sectionState.phases ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </div>

          <div v-show="sectionState.phases">
            <div class="form-group row">
              <div class="col-lg-12"><br>

                <!-- LOADING -->
                <div v-if="isPhaseLoading" class="text-muted">
                  Loading phases...
                </div>

                <!-- NO PHASES -->
                <div v-else-if="phaseOptions.length === 0" class="text-muted">
                  No phases added for this study
                </div>

                <!-- PHASES AVAILABLE -->
                <div v-else>

                  <div class="phase-description mb-0">
                    <label class="mb-1">
                      Choose one or more phases. Visit schedules will be created based on planned dates.
                    </label>
                  </div>

                  <div class="d-flex flex-wrap gap-3 mt-2">
                    <div class="phase-selector">
                      <label v-for="phase in phaseOptions" :key="'phase-' + phase.value" class="phase-chip"
                        :class="{ activephase: selectedPhases.includes(phase.value) }">
                        <input type="checkbox" :value="phase.value" v-model="selectedPhases"
                          @change="onPhaseToggle(phase.value)" />
                        {{ phase.label }}
                      </label>
                    </div>
                  </div>

                </div>

              </div>
            </div>

            <div v-for="phase in phaseOptions.filter(p => selectedPhases.includes(p.value))"
              :key="'phase-' + phase.value" class="mt-0 subreg">
              <h5 class="mb-0">{{ phase.label }}</h5>

              <!-- Special case: Screening Date -->
              <div v-if="phase.value === 'Screening'" class="row mb-0">
                <div class="col-lg-4">
                  <label class="mb-0">  
                    Screening Date
                    <sup><i class="fa fa-asterisk required"></i></sup>
                  </label>
                  <input type="date" class="form-control" v-model="values.screeningDate" />
                  <small class="errorClass" v-if="!validations[4]">
                    Screening Date is required
                  </small>
                </div>
              </div>

              <!-- VISITS TABLE -->
              <div class="row mt-1">
                <div class="col-lg-12 mb-1 ">
                  <div class="table-responsive" v-if="groupedVisits[phase.value]">

                    <table class="table table-bordered table-sm mb-0">
                      <thead>
                        <tr>
                          <th style="width: 50%">Visit Name</th>
                          <th style="width: 50%">Planned Date <sup><i class="fa fa-asterisk required"></i></sup></th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr v-for="visit in groupedVisits[phase.value]" :key="visit.visitId">
                          <td>{{ visit.visitFormName }}</td>
                          <td>
                            <input type="date" class="form-control" v-model="visit.plannedDate" />
                            <span 
                              class="errorClass"
                              v-if="errors.includes('visitDate') && !visit.plannedDate" > 
                                {{ $t("navigations.please choose a date") }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
              </div>


            </div>
            <div class="form-group row">
              <div class="col-lg-6 mt-4">
                <label>
                  Mark subject as screen failure
                </label>&nbsp;

                <input type="checkbox" v-model="values.isScreeningFailed" />
              </div>
              <div class="col-lg-6" v-if="values.isScreeningFailed">
                <label>
                  Reason for screening failure
                </label>&nbsp;

                <input type="text" class="form-control" v-model="values.screeningFailureReason" />
              </div>
            </div>

          </div>
        </div>

        <!-- ENROLLMENT-->
        <div>
          <div class="section-header d-flex justify-content-between align-items-center mt-3"
            @click="toggleSection('enrollment')">

            <h4 class="mb-0">Subject Enrolment</h4>

            <i class="fa" :class="sectionState.enrollment ? 'fa-chevron-up' : 'fa-chevron-down'">
            </i>

          </div>

          <div v-show="sectionState.enrollment">

            <div class="form-group row d-flex align-items-center">

              <div class="col-lg-6 ">
                <label class="mb-0">
                  Do you want to schedule visits for this subject?
                </label>&nbsp;

                <input type="checkbox" v-model="values.isSchedule" @change="handleCheck($event)" />

              </div>

              <div class="col-lg-4">

                <label class="mb-0">
                  {{ $t("navigations.planned enrolment date") }}
                  <sup v-if="values.isSchedule">
                    <i class="fa fa-asterisk required"></i>
                  </sup>

                </label>

                <input type="date" class="form-control" v-model="values.enrollmentDate" />
                <!-- ERROR -->
                <small class="errorClass" v-if="errors.length && !validations[2]">
                  Enrollment Date is required
                </small>

              </div>
            </div>

          </div>
        </div>
        <div class="col-lg-12 mt-4">

          <div class="d-flex justify-content-end">

            <button class="cancel_btn py-1 px-4 mx-3" @click="clearForm()">

              {{ $t("navigations.clear") }}

            </button>
            <!-- <button class="save_btn py-1 px-4" @click="saveOrEditPatient()">

              {{ $t("navigations.save") }}

            </button> -->
           <button class="save_btn py-1 px-4" :disabled="isSaving" @click="saveOrEditPatient()">
               <span v-if="isSaving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span v-else>{{ $t("navigations.save") }}</span>
            </button>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script src="./ManageSubjectModal.js"></script>

<style scoped>
.study_profile_modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 3000;
}

.study_profile_modal__container {
  border-radius: 4px;
  background: #fff;
  width: min(1000px, 90%);
  max-height: 90vh;

  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* important */
}

/* HEADER stays fixed */
.modal__title {
  background-color: var(--pop-up-background);
  color: white;
  flex-shrink: 0;
  /* prevents shrinking */
  position: sticky;
  top: 0;
  z-index: 10;
}

/* SCROLL ONLY THIS */
.ibox-content {
  overflow-y: auto;
  flex-grow: 1;
}

.cancel_btn {
  padding: 0.43rem 0.4rem;
  border-radius: 0.25rem;
}

.custom-width {
  width: min(1000px, 90%);
}

.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.custom-tooltip {
  visibility: hidden;
  width: 60px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: -25%;
  /* Position the tooltip above the icon */
  left: -375%;
  margin-left: -30px;
  /* Use half of the width to center-align */
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 12px;
}

.tooltip-wrapper:hover .custom-tooltip {
  visibility: visible;
  opacity: 1;
}

.section-header {
  cursor: pointer;
  padding: 4px 8px;
  background-color: #dbe7e7;
  border: 0px;
  border-radius: 5px;
}

.section-header h5 {
  font-size: 13px;
  font-weight: 600;
}

.phase-selector {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

/* CHIP */
.phase-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1.5px solid #d1dde8;
  border-radius: 6px;
  padding: 1px 5px;
  cursor: pointer;
  background: #f8fafc;
  font-size: 13px;
  font-weight: 500;
  color: #4a6080;
  transition: all 0.2s ease;
  user-select: none;
}

/* Hide default checkbox */
.phase-chip input {
  width: 16px;
  height: 16px;
  accent-color: #2563eb;
  cursor: pointer;
}

/* Hover */
.phase-chip:hover {
  border-color: #2563eb;
  background: #dbeafe;
  color: #1d4ed8;
}

/* Active (selected) */
.phase-chip.activephase {
  border-color: #2563eb;
  background: #dbeafe;
  color: #1d4ed8;
}
.subreg h5{
  font-size: 16px;
  font-weight: 500;
}
</style>